<template>
  <section class="lives-saved-section">
    <h2>สถิติที่ได้ช่วยเหลือไปแล้ว</h2>
    <container>
      <div class="col-6 col-md-3 cases-number">
        <p>{{ livesSaved.dog }}</p>
        Cases
      </div>
      <div class="col-12 col-md-6">
        <img class="img-fluid dog-cat-img" src="@/assets/other/dog-cat-blood.png" alt="dog cat blood bag">
      </div>
      <div class="col-6 offset-6 col-md-3 offset-md-0 cases-number">
        <p>{{ livesSaved.cat }}</p>
        Cases
      </div>
      <div class="col-sm-12 mb-2"><hr/></div>
    </container>
    <h2>คำขอบคุณจากผู้รับเลือด</h2>
    <comment-panel/>
    <container>
      <div class="col-sm-12 mb-2"><hr/></div>
      <div class="col-sm-12 col-lg-8">
        <h2>เป็นส่วนหนึ่งของการต่อชีวิตสัตว์เลี้ยง</h2>
      </div>
      <div class="col-sm-12 col-lg-4">
        <router-link :to="{ name: 'donation'}" class="btn btn-primary btn-block">ร่วมบริจาคเลือด</router-link>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'
import CommentPanel from '@/components/CommentPanel.vue'

export default {
  name: 'LivesSavedSection',
  data () {
    return {
      livesSaved: {
        dog: 456,
        cat: 123
      }
    }
  },
  components: {
    Container,
    CommentPanel
  }
}
</script>

<style scoped lang="scss">
.lives-saved-section {
  padding: 2rem 0;
  h2 {
    text-align: center;
    padding: 0 1rem;
    font-size: $h3-font-size;
  }
  .cases-number {
    text-align: center;
    margin-top: 0rem;
    p {
      font-size: $h2-font-size;
      margin: 0;
      line-height: 1.25;
    }
  }
  .dog-cat-img {
    margin-bottom: 1rem;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .lives-saved-section {
    h2 {
      font-size: $h2-font-size;
    }
    .cases-number {
      p {
        font-size: $h1-font-size;
      }
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .lives-saved-section {
    .cases-number {
      margin-top: 3rem;
    }
  }
}
</style>
